import { pageNames } from "@shared/routes/pageNames";

const constantsUnlockFeatureTag = {
	[pageNames.myScore.path]: "SCORE",
	[pageNames.scoreKbaQuestions.path]: "SCORE",
	[pageNames.account.path]: "DADOS CADASTRAIS",
};

export default constantsUnlockFeatureTag;
